import React from 'react';
import {CyClass} from '../../../../../common/cy-classes';
import {BurgerMenuContainerBox} from "./boxes/container/burger-menu-container.box";
import {ComponentServicesPick} from "../../../../services/component-services-pick";
import {observer} from "mobx-react";
import {useServices} from "../../../../react-hooks/use-services.hook";
import {withServices} from "../../../../react-hooks/with-services";

interface MobileBurgerMenuComponentProps extends ComponentServicesPick<'sideMenu'>{
  
}

const ComponentBody: React.FC<MobileBurgerMenuComponentProps> = observer((props) => {
  const services = useServices();
  const _clickHandler = () => {
    services.analytics.sendOrbitUserFlowEvent("Navigation","NavBar", "Open_Burger");
    props.sideMenu.openMobileMenu();
  };

  const _getIcon = () => {
    if (services.abTestingFeatureDataProvider.mobileHeaderSearchButtonEnabled) {
      return services.theme.currentTheme.icons.mobileMenuNoSearchIcon;
    }
    return services.theme.currentTheme.icons.mobileMenuIcon;
  }

  const MobileMenuIcon = _getIcon();
  return (
      <BurgerMenuContainerBox  onClick={_clickHandler}>
        <MobileMenuIcon className={`${CyClass('cy-burger-button')}`} size={1.8} sizeIsHeight />
      </BurgerMenuContainerBox>
  );

})

export const MobileBurgerMenuComponent = withServices(ComponentBody, ['sideMenu']);
